import { ClaimFlowType } from 'types';

import useCreateLandingPageHook, {
  ClaimType,
} from 'components/SubPages/Landing/useCreateLandingPageHook';

import useP2PEnrollmentFlow from 'hooks/useP2PEnrollmentFlow';
import { useUserContext } from 'hooks/useUserContext';

import {
  trackCTATapped,
  trackLandingPageViewed,
} from 'utils/segment/trackingEvents';

type UsePayAnyoneLandingApi = {
  onCtaClickDebit: () => void;
  onCtaClickChime: () => void;
  navigateToEnrollment: (callback: () => void) => void;
  navigateToLogin: () => void;
};

const usePayAnyoneLandingPage = (): UsePayAnyoneLandingApi => {
  const [userData] = useUserContext();
  const {
    publicId,
    senderId,
    amount,
    claimWithChime: isClaimWithChimeEnabled,
  } = userData;

  const { activateP2pEnrollmentAndNavigate } = useP2PEnrollmentFlow(
    isClaimWithChimeEnabled,
    amount
  );
  const {
    activateP2pEnrollmentAndNavigate: activateP2pEnrollmentAndNavigateToLogin,
  } = useP2PEnrollmentFlow(false, amount);

  const navigateToLogin = () => {
    activateP2pEnrollmentAndNavigateToLogin(() =>
      fireCtaTappedEvents(ClaimType.DEBIT_CARD)
    );
  };

  const fireLandingPageViewedEvents = () => {
    trackLandingPageViewed(amount, publicId, senderId, ClaimFlowType.pay);
  };

  const fireCtaTappedEvents = (claimType: ClaimType) =>
    trackCTATapped(
      'Pay Anyone',
      'Get $',
      'Landing Page',
      'get_money_button',
      publicId,
      claimType
    );

  const { onCtaClickDebit, onCtaClickChime } = useCreateLandingPageHook(
    fireCtaTappedEvents,
    fireLandingPageViewedEvents
  );

  const handleDebitClick = () => {
    onCtaClickDebit();
  };

  return {
    onCtaClickDebit: handleDebitClick,
    onCtaClickChime,
    navigateToEnrollment: activateP2pEnrollmentAndNavigate,
    navigateToLogin,
  };
};

export default usePayAnyoneLandingPage;
